"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifiedAddressUpdate = exports.VerifiedAddressDetails = exports.VerifiedAddressItem = exports.UserVerifiedAddressAccordion = exports.VerifiedAddressAccordion = exports.UserVerifiedAddressListGroup = exports.VerifiedAddressListGroup = exports.AddressAccordion = exports.AddressListGroup = void 0;
// tslint:disable:jsx-no-multiline-js
var react_1 = __importStar(require("react"));
var bindings_1 = require("../bindings");
var Accordion_1 = __importStar(require("./Accordion"));
var List_1 = require("./List");
var classnames_1 = __importDefault(require("classnames"));
var AddressListGroup = function (Cmp) { return function (props) { return (react_1.default.createElement(Cmp, __assign({}, props), function (items) { return (react_1.default.createElement("ul", { className: "list-group" }, items.map(function (item) { return (react_1.default.createElement("li", { className: "list-group-item", key: item.id },
    react_1.default.createElement(exports.VerifiedAddressItem, __assign({}, item)))); }))); })); }; };
exports.AddressListGroup = AddressListGroup;
var AddressAccordion = function (Cmp) { return function (_a) {
    var _b = _a.children, children = _b === void 0 ? react_1.default.createElement(exports.VerifiedAddressDetails, null) : _b, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Cmp, __assign({}, props), function (items) { return (react_1.default.createElement(Accordion_1.default, null, items.map(function (item) { return (react_1.default.createElement(Accordion_1.AccordionItem, { key: item.id, head: react_1.default.createElement(exports.VerifiedAddressItem, __assign({}, item)) }, (0, react_1.cloneElement)(children, item))); }))); }));
}; };
exports.AddressAccordion = AddressAccordion;
exports.VerifiedAddressListGroup = (0, exports.AddressListGroup)(List_1.VerifiedAddressList);
exports.UserVerifiedAddressListGroup = (0, exports.AddressListGroup)(List_1.UserVerifiedAddressList);
exports.VerifiedAddressAccordion = (0, exports.AddressAccordion)(List_1.VerifiedAddressList);
exports.UserVerifiedAddressAccordion = (0, exports.AddressAccordion)(List_1.UserVerifiedAddressList);
var VerifiedAddressItem = function (_a) {
    var className = _a.className, id = _a.id, address = _a.address, name = _a.name, fhr = _a.fhr;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('d-flex align-items-center', className), key: id },
        react_1.default.createElement("i", { className: "fa fa-check text-success" }),
        ' ',
        react_1.default.createElement("span", { className: "px-1 flex-grow-1", style: ellipsis }, name || address),
        fhr && react_1.default.createElement("span", { className: "badge badge-secondary" }, "FHR")));
};
exports.VerifiedAddressItem = VerifiedAddressItem;
var VerifiedAddressDetails = function (_a) {
    var address = _a.address, name = _a.name, notes = _a.notes, fhr = _a.fhr;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("b", null, "Name"),
        react_1.default.createElement("p", null, name),
        react_1.default.createElement("b", null, "Address"),
        react_1.default.createElement("p", null, address),
        react_1.default.createElement("b", null, "Notes"),
        react_1.default.createElement("p", null, notes)));
};
exports.VerifiedAddressDetails = VerifiedAddressDetails;
var VerifiedAddressUpdate = function (_a) {
    var id = _a.id, address = _a.address, name = _a.name, notes = _a.notes;
    var mutate = (0, bindings_1.useTagAddressMutation)()[0];
    var _b = (0, react_1.useState)(null), error = _b[0], setError = _b[1];
    var _c = (0, react_1.useState)({
        name: name,
        notes: notes,
    }), values = _c[0], setValues = _c[1];
    var onSubmit = function (ev) { return __awaiter(void 0, void 0, void 0, function () {
        var variables, e_1, err;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ev.preventDefault();
                    if (!mutate || !id)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    variables = { id: id, name: values.name, notes: values.notes };
                    return [4 /*yield*/, mutate({
                            variables: variables,
                            optimisticResponse: {
                                tag: __assign(__assign({}, variables), { __typename: 'VerifiedAddress', address: address }),
                            },
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    err = e_1;
                    setError(err.message);
                    console.error(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (ev) {
        var _a;
        var name = ev.target.name;
        var value = ev.target.value;
        setValues(__assign(__assign({}, values), (_a = {}, _a[name] = value, _a)));
    };
    return (react_1.default.createElement("form", { onSubmit: onSubmit },
        error && react_1.default.createElement("div", { className: "alert bg-danger text-white" }, error),
        react_1.default.createElement("b", null, "Address"),
        react_1.default.createElement("p", null, address),
        react_1.default.createElement("div", { className: "form-group" },
            react_1.default.createElement("label", null, "Name"),
            react_1.default.createElement("input", { className: "form-control", name: "name", value: values.name || '', onChange: handleChange })),
        react_1.default.createElement("div", { className: "form-group" },
            react_1.default.createElement("label", null, "Notes"),
            react_1.default.createElement("textarea", { className: "form-control", name: "notes", value: values.notes || '', onChange: handleChange })),
        react_1.default.createElement("button", { className: "btn btn-primary" }, "Save")));
};
exports.VerifiedAddressUpdate = VerifiedAddressUpdate;
var ellipsis = {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
};
//# sourceMappingURL=Display.js.map